import { IAppState } from '../../redux';

export const selectIsSubagent = (state: IAppState): boolean => {
  return state.user.isSubAgent;
};
